import { createContext, useCallback, useContext, useState } from "react";
import { api, hasBackend } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const check = useCallback(() => {
    if (!hasBackend) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) sessionStorage.setItem("wnx_token", data.token);
    setUser(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    sessionStorage.removeItem("wnx_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, check, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
